import { Box, Typography } from '@mui/material';
import React from 'react';
import logoAlertAiEducation from '../../../../assets/images/favicon.png';
import walpaperAdventista from '../../../assets/adventista.jpg';

interface PdfViewerProps {
  formData: { image1?: File | null; image2?: File | null };
  formaDataContext?: { logos?: (File | null)[] };
  boxRef: React.Ref<unknown>;
}

const PdfViewerThird: React.FC<PdfViewerProps> = ({
  formData,
  boxRef,
  formaDataContext,
}) => {
  return (
    <Box
      sx={{
        width: '95vw',
        height: '90vh',
        maxWidth: 'calc(93vh * 0.700)',
        aspectRatio: '1 / 1.414',
        backgroundColor: 'white',
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        margin: 'auto',
        position: 'relative',
      }}
      ref={boxRef}
    >
      <Box
        sx={{
          height: '100%',
          width: '7vh',
          backgroundColor: '#224FA2',
        }}
      />

      <div style={{ width: '100%' }}>
        <Typography
          sx={{
            fontSize: '2.5rem',
            width: '60%',
            fontWeight: 'bold',
            color: '#224FA2',
            marginBottom: '1rem',
            lineHeight: 1,
            paddingLeft: '24px',
          }}
        >
          Modelos de aquisição
        </Typography>
        <Box
          sx={{
            width: '40%',
            height: '5px',
            marginLeft: '24px',
            marginBottom: '2rem',
            backgroundColor: '#54B55D',
            zIndex: 1,
          }}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'Column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '13vh',
            marginBottom: '2rem',
          }}
        >
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                width: '24vh',
                height: '40px',
                backgroundColor: '#3974BB',
                borderTopRightRadius: '15px',
                borderBottomRightRadius: '15px',
                marginRight: '8px',
              }}
            >
              <Typography
                sx={{
                  fontSize: '1.3rem',
                  width: '65%',
                  fontWeight: 'bold',
                  color: 'white',
                  lineHeight: 1,
                }}
              >
                Hardware
              </Typography>
            </Box>
          </Box>
          <Typography
            sx={{
              fontSize: '0.8rem',
              width: '85%',
              py: '1rem',
              fontWeight: 'bold',
              color: '#224FA2',
              lineHeight: 1,
            }}
          >
            Oferecemos a opção de aquisição dos equipamentos através da compra,
            com formas de pagamento diferenciadas.
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'Column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '13vh',
            marginBottom: '2rem',
          }}
        >
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                width: '24vh',
                height: '40px',
                backgroundColor: '#3974BB',
                borderTopRightRadius: '15px',
                borderBottomRightRadius: '15px',
                marginRight: '8px',
              }}
            >
              <Typography
                sx={{
                  fontSize: '1.4rem',
                  width: '65%',
                  fontWeight: 'bold',
                  color: 'white',
                  lineHeight: 1,
                }}
              >
                Locação
              </Typography>
            </Box>
          </Box>
          <Typography
            sx={{
              fontSize: '0.8rem',
              width: '85%',
              py: '1rem',
              fontWeight: 'bold',
              color: '#224FA2',
              lineHeight: 1,
            }}
          >
            Você não precisa desembolsar o valor para adquirir os equipamentos,
            com a locação ofertamos a possibilidade de você investir um pequeno
            valor mensal para desfrutar dos equipamentos.
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'Column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '13vh',
            marginBottom: '1rem',
          }}
        >
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                width: '40vh',
                height: '40px',
                backgroundColor: '#3974BB',
                borderTopRightRadius: '15px',
                borderBottomRightRadius: '15px',
                marginRight: '8px',
              }}
            >
              <Typography
                sx={{
                  fontSize: '1.4rem',
                  width: '65%',
                  fontWeight: 'bold',
                  color: 'white',
                  lineHeight: 1,
                }}
              >
                Softwares - SAS
              </Typography>
            </Box>
          </Box>
          <Typography
            sx={{
              fontSize: '0.8rem',
              width: '85%',
              py: '1rem',
              fontWeight: 'bold',
              color: '#224FA2',
              lineHeight: 1,
            }}
          >
            A aquisição do software é no formato de licenças. Você paga um valor
            mensal na aquisição de licenças e usuários.
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 2,
            width: '100%',
            mt: '2rem',
            height: '6vh',
            paddingLeft: '24px',
          }}
        >
          {(formaDataContext?.logos ?? [])
            .filter((logo): logo is File => logo instanceof File)
            .map((logo, index) => (
              <img
                key={index}
                src={URL.createObjectURL(logo)}
                alt={`Logo ${index + 1}`}
                style={{
                  height: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain',
                }}
              />
            ))}

          <img
            src={logoAlertAiEducation}
            alt="Logo AlertAi"
            style={{
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </Box>
      </div>
    </Box>
  );
};

export default PdfViewerThird;
